<form class="edit-form" *ngIf="!isLoading && clients" [formGroup]="editForm" (submit)="onSubmit()">

  <mat-form-field>
    <mat-label>{{ 'repository.containers.edit.identifier.label' | translate }}</mat-label>
    <input type="text" matInput formControlName="identifier">
    <mat-error>{{ 'repository.containers.edit.identifier.errorMessage' | translate }}</mat-error>
  </mat-form-field>

  <mat-form-field>
    <mat-label>{{ 'repository.containers.edit.description.label' | translate }}</mat-label>
    <input type="text" matInput formControlName="description">
    <mat-error>{{ 'repository.containers.edit.description.errorMessage' | translate }}</mat-error>
  </mat-form-field>

  <app-autocomplete [control]="getControl('productType')" [list]="productTypes"
    label="repository.containers.edit.productType.label" errorMsg="repository.containers.edit.productType.errorMessage">
  </app-autocomplete>

  <mat-form-field>
    <mat-label>KooveaTag</mat-label>
    <input type="text" matInput formControlName="tag">
    <mat-error>{{ 'repository.containers.edit.tag.errorMessage' | translate }}</mat-error>
  </mat-form-field>

  <app-autocomplete [control]="getControl('client')" [list]="clients" label="repository.containers.edit.client.label"
    errorMsg="repository.containers.edit.client.errorMessage">
  </app-autocomplete>

  <app-validate-and-cancel (submitEvent)="endForm($event)" [editForm]="editForm"
    [disabling]="editForm.invalid"></app-validate-and-cancel>
</form>
<mat-spinner *ngIf="isLoading" [diameter]="35" color="primary"></mat-spinner>